import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  padding: 8px 12px;
  border-radius: 12px;
  background: #f7f7f8;

  color: #414b56;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
  letter-spacing: -0.056px;
`;

interface Props {
  text: string;
  icon?: ReactNode;
  onClick: () => void;
}

const HeaderButton: FC<Props> = props => {
  const { text, icon, onClick } = props;

  return (
    <Button onClick={onClick}>
      {icon && icon}
      {text}
    </Button>
  );
};

export default HeaderButton;
